function initIngredientAccorion(container) {
  const items = container.querySelectorAll('.ingredient-accordion__item');

  if (!items.length) return;

  const isMobile = () => window.innerWidth <= 980;

  const openItem = (item, animate = false) => {
    const content = item.querySelector('.ingredient-accordion__item-description');

    item.classList.add('is-open');
    content.style.overflow = 'hidden';

    // Get the full height
    content.style.height = 'auto';
    const fullHeight = content.scrollHeight + 'px';

    if (animate) {
      content.style.height = '0px';
      content.style.paddingBottom = '0px';

      requestAnimationFrame(() => {
        content.style.height = fullHeight;
        content.style.paddingBottom = '20px';
      });
    } else {
      content.style.height = fullHeight;
      content.style.paddingBottom = '20px';
    }
  };

  const closeItem = (item, animate = false) => {
    const content = item.querySelector('.ingredient-accordion__item-description');

    if (animate) {
      content.style.height = content.scrollHeight + 'px';

      requestAnimationFrame(() => {
        item.classList.remove('is-open');
        content.style.height = '0px';
        content.style.paddingBottom = '0px';
      });
    } else {
      item.classList.remove('is-open');
      content.style.height = '0px';
      content.style.paddingBottom = '0px';
    }
  };

  // Set initial state
  items.forEach((item, index) => {
    const trigger = item.querySelector('.ingredient-accordion__item-title');
    const content = item.querySelector('.ingredient-accordion__item-description');

    if (item.dataset.initialized) return;
    item.dataset.initialized = 'true';

    content.style.overflow = 'hidden';

    // Desktop: open everything
    // Mobile: close everything
    if (isMobile()) {
      if (index === 0) {
        openItem(item);
      } else {
        closeItem(item);
      }
    } else {
      openItem(item);
    }

    trigger.addEventListener('click', () => {
      // Desktop: everything stays open
      if (!isMobile()) {
        return;
      }

      const isOpen = item.classList.contains('is-open');

      // Close all other items
      items.forEach(otherItem => {
        if (otherItem !== item) {
          closeItem(otherItem, true);
        }
      });

      // Toggle clicked item
      if (isOpen) {
        closeItem(item, true);
      } else {
        openItem(item, true);
      }
    });
  });

  // Handle desktop/mobile breakpoint changes
  if (!container.dataset.resizeInitialized) {
    container.dataset.resizeInitialized = 'true';

    let wasMobile = isMobile();

    window.addEventListener('resize', () => {
      const nowMobile = isMobile();

      // Only react when crossing the breakpoint
      if (nowMobile === wasMobile) return;

      wasMobile = nowMobile;

      if (nowMobile) {
        // Switched to mobile:
        // close all items
        items.forEach((item, index) => {
          if (index === 0) {
            openItem(item);
          } else {
            closeItem(item);
          }
        });
      } else {
        // Switched to desktop:
        // open all items
        items.forEach(item => openItem(item));
      }
    });
  }
}

document.querySelectorAll('.ingredient-accordion').forEach(section => {
  initIngredientAccorion(section);
});

document.addEventListener('shopify:section:load', function (event) {
  const section = event.target;

  if (section.classList.contains('ingredient-accordion')) {
    initIngredientAccorion(section);
  }
});
